import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';



@Component({
  selector: 'app-sms',
  templateUrl: './sms.component.html',
  styleUrls: ['./sms.component.css']
})
export class SMSComponent implements OnInit {
  SMSForm: FormGroup;
  patPhoneNum:any
  formErrors = {
    'message': '',
  }
  validationMessages = {
    'message': {
      'required': 'message is required.',
    },
  }

  constructor(public dialogRef: MatDialogRef<SMSComponent>
    ,@Inject(MAT_DIALOG_DATA) public data: any
    ,public dialog: MatDialog
    ,private fb: FormBuilder,) { }

  ngOnInit() {
    this.SMSForm = this.fb.group({
      message: ['',  Validators.required],
    });
    ;
    this.patPhoneNum = this.data;
    this.SMSForm.markAllAsTouched();
    this.SMSForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.SMSForm);
    });
  }
  onCancelClick(): void {
    this.dialogRef.close();
  }
  onSubmit(){
    this.dialogRef.close(this.SMSForm.value.message);
  }
  logValidationErrors(group: FormGroup = this.SMSForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid
          && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
}
